import React, { useState } from "react";
import { FaClipboardList, FaMinus, FaPlus, FaShieldAlt, FaRocket, FaCheckCircle, FaUserCheck, FaDollarSign, FaLaptopMedical, FaBalanceScale, FaFileAlt, FaCheckDouble, FaChartPie, FaCreditCard } from "react-icons/fa";
import { AiOutlineApi, AiOutlineSafetyCertificate, AiOutlineAppstore, } from "react-icons/ai";
import { MdSecurity, MdIntegrationInstructions, MdSpeed, MdTrackChanges, MdMonetizationOn, MdDevices } from "react-icons/md";
import { FaUsersCog, } from "react-icons/fa";
import Medpalm from "../../../assests/EasyClaims.jpg";
import { motion } from "framer-motion";
import Footer from "../../../Component/Fooder";
const services = [
    {
        "title": "Fast & Secure Transactions",
        "description": "Leverage advanced encryption and AI-driven processing to ensure rapid, secure, and efficient claim approvals. Our automated workflows reduce paperwork, minimize delays, and prevent fraud, streamlining reimbursements for both patients and healthcare providers while maintaining the highest security standards."
    },
    {
        "title": "Seamless EHR Integration",
        "description": "Achieve flawless interoperability with leading Electronic Health Record (EHR) platforms, enabling smooth data exchange between hospitals, clinics, and insurers. This ensures accurate patient histories, reduces manual entry errors, and enhances care coordination for improved treatment outcomes."
    },
    {
        "title": "User-Friendly Platform",
        "description": "Designed for both patients and healthcare providers, our intuitive interface simplifies navigation, making it easy to submit claims, access medical records, and track reimbursement statuses. Whether you're a physician, insurer, or patient, our platform provides a seamless and efficient digital experience."
    },
    {
        "title": "Regulatory Compliance",
        "description": "Ensure full compliance with HIPAA, CMS, and other healthcare regulations with built-in security and data protection measures. Our platform safeguards patient information, ensures legal adherence, and provides healthcare organizations with the confidence to process claims securely and efficiently."
    }
]

const features = [
    { text: "Automated Claim Submission – Eliminates manual paperwork and accelerates the claim approval process.", icon: <AiOutlineApi className="text-[#2a627a] text-2xl" /> },
    { text: "Real-time Claim Tracking – Users can monitor claim status updates instantly.", icon: <AiOutlineSafetyCertificate className="text-[#2a627a] text-xl" /> },
    { text: "Seamless Integration – Works with various insurance providers and EHR systems.", icon: <AiOutlineAppstore className="text-[#2a627a] text-xl" /> },
    { text: "AI-powered Fraud Detection – Ensures secure transactions and prevents false claims.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
    { text: "Error-free Processing – Reduces human errors through automated validation.", icon: <FaUsersCog className="text-[#2a627a] text-xl" /> },
    { text: "Secure Data Management – Advanced encryption protects patient and claim data.", icon: <MdIntegrationInstructions className="text-[#2a627a] text-xl" /> },
    { text: "Paperless Workflow – Digital documentation for a hassle-free experience.", icon: <FaClipboardList className="text-[#2a627a] text-lg" /> },
];


const benefits = [
    { text: "Enhancing Efficiency – Reduces processing delays and speeds up claim approvals.", icon: <FaRocket className="text-[#2a627a] text-xl" /> },
    { text: "Minimizing Rejections – Automated validation helps in submitting accurate claims.", icon: <FaCheckCircle className="text-[#2a627a] text-xl" /> },
    { text: "Improving Patient Experience – Faster claims mean less financial burden on patients.", icon: <FaUserCheck className="text-[#2a627a] text-xl" /> },
    { text: "Optimizing Revenue Cycle Management (RCM) – Ensures timely reimbursements for healthcare providers.", icon: <FaDollarSign className="text-[#2a627a] text-xl" /> },
    { text: "Regulatory Compliance – Meets CMS and HIPAA standards for secure transactions.", icon: <FaShieldAlt className="text-[#2a627a] text-xl" /> },
];

const cmsFeatures = [
    { text: "Enhancing Efficiency – Reduces processing delays and speeds up claim approvals.", icon: <MdSpeed className="text-[#2a627a] text-xl" /> },
    { text: "Minimizing Rejections – Automated validation helps in submitting accurate claims.", icon: <FaCheckDouble className="text-[#2a627a] text-xl" /> },
    { text: "Improving Patient Experience – Faster claims mean less financial burden on patients.", icon: <FaUserCheck className="text-[#2a627a] text-xl" /> },
    { text: "Optimizing Revenue Cycle Management (RCM) – Ensures timely reimbursements for healthcare providers.", icon: <MdMonetizationOn className="text-[#2a627a] text-xl" /> },
    { text: "Regulatory Compliance – Meets CMS and HIPAA standards for secure transactions.", icon: <FaBalanceScale className="text-[#2a627a] text-xl" /> },
    { text: "AI-Powered Fraud Detection – Prevents false claims and ensures security.", icon: <FaShieldAlt className="text-[#2a627a] text-xl" /> },
    { text: "Seamless EHR Integration – Works smoothly with electronic health records.", icon: <FaLaptopMedical className="text-[#2a627a] text-xl" /> },
    { text: "Real-time Claim Tracking – Users can monitor claim status instantly.", icon: <MdTrackChanges className="text-[#2a627a] text-xl" /> },
    { text: "Secure Data Management – Advanced encryption protects patient and claim data.", icon: <MdSecurity className="text-[#2a627a] text-xl" /> },
    { text: "Paperless Workflow – Digital documentation for a hassle-free experience.", icon: <FaFileAlt className="text-[#2a627a] text-xl" /> },
    { text: "Customizable Dashboard – Tailored insights for providers and patients.", icon: <FaChartPie className="text-[#2a627a] text-xl" /> },
    { text: "Multi-Device Accessibility – Access claims and reports anytime, anywhere.", icon: <MdDevices className="text-[#2a627a] text-xl" /> },
    { text: "Automated Payment Processing – Simplifies transactions and reduces delays.", icon: <FaCreditCard className="text-[#2a627a] text-xl" /> }
];

const Easyclams = () => {
    const [openIndex, setOpenIndex] = useState(0);
    return (
        <>
            <div className="min-h-screen mt-10 p-8 bg-white w-full flex flex-col items-center shadow-lg rounded-lg">
                {/* <div className="min-h-screen mt-10 p-8 bg-gradient-to-t from-[#78ffa5] to-[#03ab3b] w-full flex flex-col items-center shadow-lg rounded-lg"> */}
                {/* Header Section */}
                <div className=" text-center w-full">
                    <h1 className="font-semibold text-[30px] flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800"> Smarter Claims, Better Care - <span className="text-gray-800">HikeHealth GS</span> </h1>
                    <p className="text-gray-800 mt-3 text-sm">
                        Experience fast, accurate, and secure claims processing, ensuring smooth reimbursements with minimal hassle.
                    </p>
                </div>

                {/* What is Blue Button 2.0? */}
                <section className="mt-8 flex flex-col md:flex-row  bg-gray-300 p-6 bg-opacity-80 drop-shadow-2xl rounded-xl items-center">
                    <img draggable={false}src={Medpalm} alt="Healthcare Tech" className="rounded-lg shadow-xl  w-full md:w-1/5" />
                    <div className="md:ml-6 mt-2 md:mt-0">
                        <h2 className="text-[30px] font-extrabold text-[#2a627a]">What is Smarter Claims Processing?</h2>
                        <p className="text-gray-800 mt-2 text-sm text-wrap">
                            Easy Claims Processing refers to the seamless and efficient management of insurance claims, ensuring quick approvals, minimal paperwork, and secure transactions. HikeHealth GS integrates advanced technology to automate claim submissions, verify documents, and reduce processing time.
                        </p>
                    </div>


                </section>

                {/* Role in CMS Compliance */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Role in  Smarter Claims
                    </h2>
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {cmsFeatures.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 bg-opacity-100 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, y: 30, filter: "blur(10px)" }} // Fade-in + Blur + Bounce effect
                                whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
                                transition={{ duration: 0.8, ease: "easeOut", delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <span className="text-gray-800 text-sm font-medium">{item.text}</span>
                            </motion.div>
                        ))}
                    </div>
                </section>

                {/* Key Features Section */}
                <section className="mt-6 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800 p-2">
                        Key Features
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {features.map((item, index) => (
                            <motion.div
                                key={index}
                                className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow"
                                initial={{ opacity: 0, x: index % 2 === 0 ? -50 : 50 }} // Left & Right split
                                whileInView={{ opacity: 1, x: 0 }} // Move to center
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}
                            >
                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>


                {/* Benefits Section */}
                <section className="mt-8 w-full">
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-r from-[#2a627a] rounded-xl text-gray-800">
                        Benefits
                    </h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-6 mt-4 max-w-5xl mx-auto px-4">
                        {benefits.map((item, index) => (
                            <motion.div key={index} className="flex items-center space-x-3 bg-gray-300 p-4 rounded-lg shadow" initial={{ opacity: 0, scale: 0.8, y: 40 }}
                                whileInView={{ opacity: 1, scale: 1, y: 0 }}
                                transition={{ type: "spring", stiffness: 100, duration: 0.8, damping: 8, delay: index * 0.1 }}
                                viewport={{ once: false, amount: 0.3 }}>

                                {item.icon}
                                <p className="text-gray-800 text-sm font-medium">{item.text}</p>
                            </motion.div>
                        ))}
                    </div>
                </section>




                {/* Services Section */}
                <section className="mt-12 w-full  mx-auto">
                    {/* Heading */}
                    <h2 className="text-[30px] font-semibold flex justify-center items-center bg-gradient-to-l from-[#2a627a] rounded-xl text-gray-800">
                        Discover Our Services
                    </h2>

                    {/* Service List */}
                    <div className=" grid grid-cols-1 md:grid-cols-1 gap-6 mt-4 max-w-5xl mx-auto px-4 ">
                        {services.map((service, index) => (
                            <div key={index} className="border-b border-gray-800">
                                {/* Service Title */}
                                <button
                                    className=" w-full flex justify-between items-center py-4 text-lg font-medium text-gray-800 focus:outline-none"
                                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                                >
                                    {service.title}
                                    {openIndex === index ? (
                                        <FaMinus className="text-red-500" />
                                    ) : (
                                        <FaPlus className="text-gray-600" />
                                    )}
                                </button>

                                {/* Service Description (Expandable with Animation) */}
                                <motion.div
                                    initial={{ height: 0, opacity: 0 }}
                                    animate={openIndex === index ? { height: "auto", opacity: 1 } : { height: 0, opacity: 0 }}
                                    transition={{ duration: 0.3, ease: "easeInOut" }}
                                    className="overflow-hidden"
                                >
                                    <p className="text-gray-600 text-sm pb-4">{service.description}</p>
                                </motion.div>
                            </div>
                        ))}
                    </div>
                </section>

            </div>
            <Footer />
        </>
    );
};

export default Easyclams;
